module.exports = __webpack_public_path__ + "img/premium_survey_tag.2168f742.png";